import React, {useCallback, useState} from "react"
import {IncidentSelector} from "@/components/paginated-selector/incident-selector";
import {useNavigate} from "react-router-dom";
import {Action, ActionSelect} from "@/components/ui/ActionSelect";

type Incident = {
    id: string;
    categoryName: string;
    typeName: string;
    severity: string;
    summary: string;
    countryISO: string;
    feedID: string;
    tags: string[];
    startedAt: string;
}

export function IncidentListPage() {
    const navigate = useNavigate();
    const [refreshKey, setRefreshKey] = useState(0);



    return (
        <div className="flex flex-col gap-4">
            <div className="flex justify-between items-center">
                <h1 className="text-2xl font-semibold">Incidents</h1>
            </div>
            <div className="">
                <IncidentSelector
                    key={refreshKey}
                />
            </div>
        </div>
    )
}
